import { supabase } from "../supabaseClient"
import {
  DEFAULT_ENHANCED_MEASUREMENT_SETTINGS,
} from "../utils/ga4EnhancedMeasurement"

const baseSettings = {
  googleSignalsState: { value: "GOOGLE_SIGNALS_ENABLED", action: "manage" },
  timeZone: { value: "America/Chicago", action: "manage" },
  currencyCode: { value: "USD", action: "manage" },
  industryCategory: { value: "ARTS_AND_ENTERTAINMENT", action: "manage" },
  reportingIdentity: { value: "BLENDED", action: "manage" },
  userDataRetention: { value: "FOURTEEN_MONTHS", action: "manage" },
  eventDataRetention: { value: "FOURTEEN_MONTHS", action: "manage" },
  resetUserDataOnNewActivity: { value: "true", action: "manage" },
}

const defaultTemplate = {
  propertyTypes: {
    PROPERTY_TYPE_ORDINARY: baseSettings,
    PROPERTY_TYPE_360: JSON.parse(JSON.stringify(baseSettings)),
  },
  customDefinitionsMode: "include",
  customDefinitions: [],
  keyEventsMode: "include",
  keyEvents: [],
  eventCreateRulesMode: "include",
  eventCreateRules: [],
  eventEditRulesMode: "include",
  eventEditRules: [],
  bigQueryLinksAction: "dont-manage",
  bigQueryLinks: [],
  channelGroupings: [],
  enhancedMeasurementSettings: {
    ...DEFAULT_ENHANCED_MEASUREMENT_SETTINGS,
  },
  userAccess: {
    expectedUsers: [],
  },
  meta: {
    defaultPropertyType: "PROPERTY_TYPE_ORDINARY",
  },
}

export async function listTemplates(orgId) {
  try {
    let query = supabase
      .from("ga4_templates")
      .select("id, name, template, organization_id")
      .order("created_at")
    if (orgId != null)
      query = query.or(`organization_id.eq.${orgId},organization_id.is.null`)
    else query = query.is("organization_id", null)
    const { data, error } = await query
    if (error) throw error
    return data
  } catch (e) {
    console.error("Failed to list GA4 templates", e)
    return []
  }
}

export async function loadTemplate(id) {
  try {
    if (id) {
      const { data, error } = await supabase
        .from("ga4_templates")
        .select("id, name, template, organization_id")
        .eq("id", id)
        .maybeSingle()
      if (!error && data) return data
    }
  } catch (e) {
    console.error("Failed to load GA4 template", e)
  }
  return { id: null, name: "Default", template: defaultTemplate, organization_id: null }
}

export async function saveTemplate({ id, name, template, orgId }) {
  try {
    if (id) {
      const { error } = await supabase
        .from("ga4_templates")
        .update({ name, template, organization_id: orgId })
        .eq("id", id)
      if (error) throw error
      return id
    } else {
      const { data, error } = await supabase
        .from("ga4_templates")
        .insert({ organization_id: orgId, name, template })
        .select("id")
        .single()
      if (error) throw error
      return data.id
    }
  } catch (e) {
    console.error("Failed to save GA4 template", e)
    throw e
  }
}

export async function deleteTemplate(id) {
  try {
    const { error } = await supabase
      .from("ga4_templates")
      .delete()
      .eq("id", id)
    if (error) throw error
  } catch (e) {
    console.error("Failed to delete GA4 template", e)
    throw e
  }
}

export { defaultTemplate }
